import { render } from "./DomainDetail.vue?vue&type=template&id=05bbfed2&scoped=true"
import script from "./DomainDetail.vue?vue&type=script&lang=js"
export * from "./DomainDetail.vue?vue&type=script&lang=js"

import "./DomainDetail.vue?vue&type=style&index=0&id=05bbfed2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05bbfed2"]])

export default __exports__